<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px; width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Subscriber Email Dashboard</h1>
            </div>
            <div class="dropdown" style="margin: 10px 0;">
                <p-calendar [(ngModel)]="date" dateFormat="dd-mm-yy" [showIcon]="true" placeholder="Select Date"
                    (ngModelChange)="onDateChange($event)"></p-calendar>
            </div>
        </div>
    </ng-container>
</div>